export default {"src":"/_next/static/media/overview-icon.b0be2687.svg","height":10,"width":36,"blurWidth":0,"blurHeight":0};